import cx from "classnames";

import styles from "../../styles/Tooltip.module.less";

type TooltipProps = {
  content: React.ReactNode;
  isEnabled: boolean;
  children: React.ReactNode;
  className?: string;
  position?: "above" | "below";
};

const Tooltip = ({ content, isEnabled, children, className, position = "above" }: TooltipProps) => {
  if (!isEnabled) {
    return <>{children ?? null}</>;
  }

  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.children}>{children}</div>
      <div className={cx(styles.tooltip, styles[`position-${position}`])}>{content}</div>
    </div>
  );
};

export default Tooltip;
